import React, { ReactNode } from "react";
import { useSelector } from "react-redux";

import Loading from "../components/Loading/Loading";
import { RootState } from "../store";

const AppAuthGuard = ({ children }: { children: ReactNode }) => {
  const isAuthenticated = useSelector((state: RootState) => state.authentication.isAuthenticated);

  if (!isAuthenticated) return <Loading />;

  return <>{children}</>;
};

export default AppAuthGuard;
